import request from '@/utils/request'
const apiPath = '/sys/technicalServiceLevel'
const technicalServiceLevelApi = {
  /**
   * 新增【技术线级别】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【技术线级别】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  updateServiceTech(data) {
    return request.put(apiPath + '/tee/updateServiceTech', data)
  },
  /**
   * 分页查询【技术线级别】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  /**
   * 查询【技术线级别】选项列表
   */
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【技术线级别】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  }
}
export default technicalServiceLevelApi
